// The GraphQL type name is misspelled `AudienceReponseOption`; the propositionType value is not.
export interface AudienceResponseOption {
  surveyId: string
  questionId: string
  responseOptionId: string
}

export interface MatrixResponseOption {
  matrixTitleId: string
  questionId: string
  responseOptionId: string
}

export interface MatrixResponseOptionCount {
  matrixTitleId: string
  questionId: string
  count: number
}

export interface MatrixRowCount {
  matrixTitleId: string
  responseOptionId: string
  count: number
}

export interface QuestionResponseOption {
  questionId: string
  responseOptionId: string
}

export interface QuestionResponseOptionCount {
  questionId: string
  count: number
}

export interface QuestionResponseOptionRank {
  questionId: string
  responseOptionId: string
  ranked: number
}

export type LogicProposition =
  | AudienceResponseOption
  | MatrixResponseOption
  | MatrixResponseOptionCount
  | MatrixRowCount
  | QuestionResponseOption
  | QuestionResponseOptionCount
  | QuestionResponseOptionRank

export enum LogicPropositionType {
  AudienceResponseOptionType = 'AudienceResponseOptionType',
  MatrixResponseOptionType = 'MatrixResponseOptionType',
  MatrixResponseOptionCountType = 'MatrixResponseOptionCountType',
  MatrixRowCountType = 'MatrixRowCountType',
  QuestionResponseOptionType = 'QuestionResponseOptionType',
  QuestionResponseOptionCountType = 'QuestionResponseOptionCountType',
  QuestionResponseOptionRankType = 'QuestionResponseOptionRankType'
}

// propositionType and proposition always travel together on the wire. Pairing them here is what
// makes a propositionType check narrow `proposition`, so no call site has to assert its shape.
interface ClauseProposition<
  T extends LogicPropositionType,
  P extends LogicProposition
> {
  clause: number
  propositionType: T
  proposition: P
  negated: boolean
}

export type AudienceClauseProposition = ClauseProposition<
  LogicPropositionType.AudienceResponseOptionType,
  AudienceResponseOption
>

export type MatrixClauseProposition = ClauseProposition<
  LogicPropositionType.MatrixResponseOptionType,
  MatrixResponseOption
>

export type MatrixCountClauseProposition = ClauseProposition<
  LogicPropositionType.MatrixResponseOptionCountType,
  MatrixResponseOptionCount
>

export type MatrixRowCountClauseProposition = ClauseProposition<
  LogicPropositionType.MatrixRowCountType,
  MatrixRowCount
>

export type QuestionClauseProposition = ClauseProposition<
  LogicPropositionType.QuestionResponseOptionType,
  QuestionResponseOption
>

export type QuestionCountClauseProposition = ClauseProposition<
  LogicPropositionType.QuestionResponseOptionCountType,
  QuestionResponseOptionCount
>

export type QuestionRankClauseProposition = ClauseProposition<
  LogicPropositionType.QuestionResponseOptionRankType,
  QuestionResponseOptionRank
>

// Exhaustive against cin-questionnaire's `LogicPropositionType`. Keep it that way: now that this is
// a union, a `never` exhaustiveness check over it will happily pass while omitting a real wire type.
export type LogicClauseProposition =
  | AudienceClauseProposition
  | MatrixClauseProposition
  | MatrixCountClauseProposition
  | MatrixRowCountClauseProposition
  | QuestionClauseProposition
  | QuestionCountClauseProposition
  | QuestionRankClauseProposition

export enum LogicClauseAsNumber {
  AND = 1,
  OR = 0
}
